###
# Модель элемента счета
###
App.InvoiceItem = DS.Model.extend
  description             : DS.attr 'string'
  amount                  : DS.attr 'number'
  price                   : DS.attr 'number'
  sum                     : DS.attr 'number'

  # Внешние связи
  invoice      : DS.belongsTo 'invoice', {async: true}
